// typed.js scriveva e cancellava il placeholder in loop infinito: main thread
// che non smette mai, su ogni pagina. E su mobile il campo vive dentro
// l'hamburger chiuso, quindi l'animazione non la vedeva nessuno.
//
// Ora la libreria è un chunk a parte, si scarica solo quando il campo entra
// davvero nel viewport, e l'avvio aspetta un momento di calma del browser.

var options = {
    strings: [
        "Cerca per marca",
        "Cerca per modello ",
        "Cerca per allestimento "
    ],
    typeSpeed: 60,
    backSpeed: 50,
    attr: "placeholder",
    smartBackspace: true,
    bindInputFocusEvents: true,
    loop: true,
};

const whenIdle = window.requestIdleCallback || ((cb) => setTimeout(cb, 200));

function startTyped(element) {
    whenIdle(() => {
        import("typed.js").then(({ default: Typed }) => new Typed(element, options));
    });
}

function startWhenVisible(element) {
    if (!element) { return; }
    if (!("IntersectionObserver" in window)) { startTyped(element); return; }

    // Un elemento in display:none non interseca mai: è esattamente il
    // comportamento che vogliamo per il campo dentro il menu chiuso.
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                startTyped(entry.target);
            }
        });
    });
    observer.observe(element);
}

startWhenVisible(document.getElementById("searchtextdesktop"));
startWhenVisible(document.getElementById("searchtextmobile"));
